export const typeProduct = [
  {value: "", label: "Выберите вариант", isDisabled: true },
  {value: 'video', label: 'Видеоролик'},
  {value: 'audio', label: 'Аудиоролик'},
  {value: 'photo', label: 'Фотосессия'},
  {value: 'news', label: 'Новостной сюжет'},
  {value: 'film', label: 'Фильм'},
  {value: 'other', label: 'Другое'},

]




export const typeWork = [
  {value: "", label: "Выберите вариант", isDisabled: true},
  {value: 'fromScratch', label: 'Разработка с нуля'},
  {value: 'adjustment', label: 'Коректировка'},
]